module.exports = __webpack_public_path__ + "static/media/close.3062e88b.svg";